import { TrackInfo } from '../../model/track-info';

export const trackDefaultIncomeBasicV2 = [
    new TrackInfo('income-wealthincome', ['income', 'income-wealthincome']),
    new TrackInfo('income-patrimony', ['income', 'patrimony']),
];

export const trackIncomeUpdateContaIon = [
    ...trackDefaultIncomeBasicV2,
    new TrackInfo('income-tax-residency-country', ['income', 'tax-residency-country']),
    new TrackInfo('income-nif', ['income', 'nif']),
    new TrackInfo('income-date-tax-res', ['income', 'date-tax-residency']),
]
